import React, { FunctionComponent } from "react";
import { WithTheme } from "src/styles/createTheme";
import styled from "@emotion/styled";
import { withTheme } from "@emotion/react";
import BaseButton from "./BaseButton";
import { darken } from "@material-ui/core/styles/colorManipulator";

const StyledLink = styled("a")`
    ${BaseButton};
    background: ${(props) => props.theme.palette.secondary.main};
    color: ${(props) => props.theme.palette.secondary.contrastText};

    :hover {
        background: ${(props) => darken(props.theme.palette.secondary.main, 0.08)};
        transition: all 0.3s ease;
    }

    :active {
        background: ${(props) => darken(props.theme.palette.secondary.main, 0.25)};
    }
`;

const SecondaryLink: FunctionComponent<React.AnchorHTMLAttributes<HTMLAnchorElement> & WithTheme> = (props) => (
    // @ts-ignore
    <StyledLink {...props} />
);

export default withTheme(SecondaryLink);
